import Styles from './AssignResultsCard.module.scss';
import { Backdrop } from '@mui/material';
import FeatherIcon from 'feather-icons-react';

export function AssignResultsCard({ showCard, setShowCard, data, translation, ...props }) {

    const closeForm = () => {
        setShowCard(false);
    }
    return (
        <>
            <Backdrop
                sx={{
                    color: '#fff',
                    zIndex: (theme) => theme.zIndex.drawer + 1
                }}
                open={showCard}
                invisible={!showCard}
            >
                <div id='formContainer' className={Styles.formContainer}>
                    <p className={Styles.formTitle}>
                        {translation('dashboard.resultsCard.title')}
                    </p>
                    <div id='inputContainer' className={Styles.inputContainer}>
                        {
                            data.length ? <table className={Styles.statusTable} >
                                <tr>
                                    {Object.keys(data[0]).map((cell, index) => {
                                        return (<th className={Styles.statusTh} >{cell}</th>);
                                    })}
                                </tr>
                                {data.map((detail, item) => (
                                    <tr >
                                        {Object.keys(detail).map((cell, index) => {
                                            if (cell === 'status') {
                                                return (
                                                    <td className={Styles.cell} >{detail[cell] ?
                                                        (
                                                            <FeatherIcon
                                                                color={'green'}
                                                                icon='check'
                                                                size='20'
                                                            />
                                                        ) : (
                                                            <FeatherIcon
                                                                color={'red'}
                                                                icon='x'
                                                                size='20'
                                                            />
                                                        )
                                                    }</td>
                                                );
                                            }
                                            return (
                                                <td className={Styles.cell}>
                                                    {detail[cell]}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                ))}
                            </table> : <>{translation('dashboard.resultsCard.none')}</>
                        }
                    </div>
                    <div id='buttonContainer' className={Styles.buttonContainer}>
                        <button
                            id='cancelButton'
                            className={Styles.cancelButton}
                            onClick={closeForm}
                        >
                            {translation('dashboard.resultsCard.button')}
                        </button>
                    </div>
                </div>
            </Backdrop></>
    )
}